<template>
  <div class="cover-right-split media-medium">
    <div class="layer media-container">
      <slot name="media"></slot>
    </div>

    <div class="layer content-container">
      <div class="content-box">
        <slot name="header"></slot>
        <slot name="jobCounter"></slot>
        <slot name="ctaButton"></slot>
        <slot name="search"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CoverRightSplit",
};
</script>

<style lang="scss" scoped>
@import "../scss/shared";
@import "../scss/media-medium";
</style>
